import React from "react";
import { useAuth0 } from "@auth0/auth0-react";
import LoginScreen from "./features/auth/LoginScreen";
import SearchPage from "./features/search/SearchPage";
import "./css/App.css";

function App() {
  const { isAuthenticated, isLoading, error } = useAuth0();

  if (error) {
    return (
      <div className="App">
        <div className="login">
          <div className="login-hero">
            <p className="login-tagline" role="alert">
              Erreur d&apos;authentification : {error.message}
            </p>
          </div>
        </div>
      </div>
    );
  }

  if (isLoading || !isAuthenticated) {
    return (
      <div className="App">
        <LoginScreen loading={isLoading} />
      </div>
    );
  }

  return (
    <div className="App">
      <SearchPage />
    </div>
  );
}

export default App;
